import React from 'react'
import Radio from 'material-ui/Radio'

const RowRadioButton = ({ value, state, changeHandler, key, compact }) => {
  return (
    <Radio
      checked={state === true ? true : false}
      onClick={changeHandler}
      value={value}
      key={key}
      style={
        compact
          ? {
              height: 24,
              padding: 0,
              width: 24
            }
          : undefined
      }
    />
  )
}

export default RowRadioButton
